/**
 * De instellingen die het opnamescherm nodig heeft.
 *
 * ACHT VELDEN ZIJN HIER WEG, en dat is de kern van fase 6:
 *
 *   ai_provider, azure_endpoint, azure_api_key, azure_model, preferred_model,
 *   prompt_soep_system, prompt_icpc_system, prompt_soep_single_problem,
 *   prompt_soep_multi_problem
 *
 * De browser deed de AI-aanroepen zelf en had daarvoor het endpoint, de sleutel en
 * de systeemprompts nodig. Ze kwamen mee in het antwoord van
 * validate-access-token. Nu roept de browser /api/ai/* aan en leest de server die
 * waarden zelf; wat hier niet staat, kan ook niet uitlekken.
 *
 * De prompts verdwijnen om een tweede reden: de client stelde ze samen uit velden
 * die hij zelf meestuurde -- doctor_phrase, provider_role, report_verbosity,
 * personal_profile. Een gemanipuleerde client kon dus bepalen met welke instructie
 * het model werkte. Die opbouw staat nu op de server, met het profiel van de
 * gebruiker die de sessie heeft.
 *
 * Wat blijft zijn de voorkeuren die de browser nodig heeft om zich te gedragen:
 * welke talen, welke triggerzin, of bellen aanstaat. En SIP, want jssip maakt de
 * WebRTC-verbinding in de client.
 */
export interface PracticeSettings {
  auto_translate: boolean;
  auto_suggest_icpc: boolean;
  doctor_phrase: string;
  read_trigger_phrase: string;
  provider_role: string;
  provider_specializations: string[];
  report_verbosity: string;
  personal_profile: string;
  force_single_soep: boolean;

  local_api_url: string;
  default_languages: string[];
  calling_enabled: boolean;
  patient_share_enabled: boolean;
  live_transcript_enabled: boolean;

  // SIP / WebRTC softphone (merged user > practice). Empty = niet geconfigureerd.
  sip_host: string;
  sip_ws_port: string;
  sip_ws_path: string;
  sip_extension: string;
  sip_password: string;
  sip_display_name: string;
  sip_stun_server: string;
  sip_dial_prefix: string;
}

export const DEFAULT_PRACTICE_SETTINGS: PracticeSettings = {
  auto_translate: true,
  auto_suggest_icpc: true,
  doctor_phrase: '',
  read_trigger_phrase: '',
  provider_role: '',
  provider_specializations: [],
  report_verbosity: 'gemiddeld',
  personal_profile: '',
  force_single_soep: false,

  local_api_url: 'http://localhost:8080/soep',
  default_languages: ['nl-NL'],
  calling_enabled: false,
  patient_share_enabled: false,
  live_transcript_enabled: false,
  sip_host: '',
  sip_ws_port: '',
  sip_ws_path: '/ws',
  sip_extension: '',
  sip_password: '',
  sip_display_name: '',
  sip_stun_server: '',
  sip_dial_prefix: '',
};

export const PROVIDER_ROLES = [
  { value: 'huisarts', label: 'Huisarts' },
  { value: 'assistent', label: 'Assistente' },
  { value: 'poh', label: 'Praktijkondersteuner (PoH)' },
] as const;

export const POH_SPECIALIZATIONS = [
  { value: 'astma', label: 'Astma' },
  { value: 'copd', label: 'COPD' },
  { value: 'dm2', label: 'DM2' },
  { value: 'cvrm', label: 'CVRM' },
  { value: 'ggz', label: 'GGZ' },
] as const;

export const REPORT_VERBOSITY_OPTIONS = [
  { value: 'beknopt', label: 'Beknopt' },
  { value: 'gemiddeld', label: 'Gemiddeld' },
  { value: 'uitgebreid', label: 'Uitgebreid' },
] as const;
